<template>
  <d-modal
    size="lg"
    :class="{ 'big-popup': true, 'is-hidden': isHidden, 'services-to-settle-popup': true }"
    @close="handleClose">
    <d-modal-header class="px-4">
      <d-modal-title>
        Zmiany w zamówieniach HPL
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="px-4">
      <d-alert
        v-if="loadError"
        show
        theme="warning"
        class="mb-4">
        Wczytywanie danych nie powiodło się.
        <a href="javascript:window.location.reload();" class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
      <template v-else>
       <div
          v-if="!loaded"
          class="text-center py-5 text-primary">
          <div
            class="spinner-border spinner-border-sm mr-2 mt-1"
            role="status">
          </div>
          Trwa ładowanie danych&hellip;
        </div>
        <d-card
          v-else
          style="width: 100%;">
          <order-sync-history
            ref="order-sync-history"
            :is-on-dashboard="true"
            :is-visible="true"
            :logs-list="logsList"
            :order-id="0" />
        </d-card>

        <pagination
          v-show="loaded"
          :meta-data="paginationMetaData" class="mt-3" />
      </template>
    </d-modal-body>
  </d-modal>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import OrderSyncHistory from '@/components/forms/order/OrderSyncHistory.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import Pagination from '@/components/common/Pagination.vue';
import debounce from 'lodash.debounce';

export default {
  name: 'orders-logs-popup',
  mixins: [
    HasPagination
  ],
  components: {
    'order-sync-history': OrderSyncHistory,
    'pagination': Pagination
  },
  data () {
    return {
      isHidden: true,
      loaded: false,
      loadError: false,
      logsList: []
    };
  },
  mounted () {
    this.$bus.$on('orders-logs-popup-show', this.openPopup);
  },
  methods: {
    handleClose () {
      this.loaded = false;
      this.loadError = false;
      this.isHidden = true;
    },
    openPopup () {
      this.currentPage = 1;
      this.loadItemsData();

      setTimeout(() => {
        this.isHidden = false;
      }, 0);
    },
    debouncedLoadFilteredData: debounce(function () {
      if (this.isHidden) {
        return;
      }
      this.loadItemsData();
    }, 250),
    loadItemsData () {
      this.loaded = false;
      this.loadError = false;

      const baseEndpoint = '/api/dashboard/stats/order-logs';

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: `${baseEndpoint}?page=${this.currentPage}`,
        listField: 'logsList',
        pagination: true
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('orders-logs-popup-show', this.openPopup);
  }
}
</script>

<style lang="scss" scoped>
.modal.is-hidden {
  display: none;
  pointer-events: none;
}

.modal-body {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}
</style>
